import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarHeadingTitle from "../../SidebarHeadingTitle";
import SidebarNavMenu from "../components/SidebarNavMenu";
import SidebarItem from "../../SidebarItem";

import {ReactComponent as HomeIcon} from "assets/img/home.svg";
import {ReactComponent as UserSquareIcon} from "assets/img/user-square-contained.svg";
import {ReactComponent as FlagIcon} from "assets/img/flag.svg";
import {ReactComponent as BoxIcon} from "assets/img/box-contained.svg";
import {ReactComponent as SortIcon} from "assets/img/sort.svg";
import {ReactComponent as BagIcon} from "assets/img/bag.svg";
import {ReactComponent as TruckIcon} from "assets/img/truck.svg";
import {ReactComponent as ScanIcon} from "assets/img/scan.svg";

import {WMSRoutes, WMSRoutesName} from "utils/WMSRoutes";
import {Authorizations, hasAuthorization} from "utils/authorizations";

import {SidebarContext} from "../../../../../SidebarContext";
import WMS from "../../../../../../../views/wms";

function WMSMenu(props) {
    const {currentMemberAuthorizations, currentPath} = useContext(SidebarContext);

    return (
        <div style={{
            padding: '12px',
            marginTop: '20px',
            marginBottom: '20px'
        }}>
            <SidebarHeadingTitle>
                <FormattedMessage id='sidebar.menu.title' />
            </SidebarHeadingTitle>
            <SidebarItem
                isTopLevel
                icon={<HomeIcon />}
                to={WMSRoutes.DASHBOARD}
                selected={currentPath === WMSRoutes.DASHBOARD}
            >
                <FormattedMessage id={WMSRoutesName.DASHBOARD} />
            </SidebarItem>
            {hasAuthorization(currentMemberAuthorizations, Authorizations.WMS_MANAGER) && (
                <>
                    <SidebarNavMenu
                        content={<FormattedMessage id={"wms.routes.sidebarNavMenu.admin"} />}
                        icon={<ScanIcon/>}
                        open={[
                            WMSRoutes.ADMIN_WMS_SUMMARY,
                            WMSRoutes.ADMIN_WMS_STATS,
                        ].includes(currentPath)}
                    >
                        <SidebarItem
                            to={WMSRoutes.ADMIN_WMS_SUMMARY}
                            selected={currentPath === WMSRoutes.ADMIN_WMS_SUMMARY}
                        >
                            <FormattedMessage id={WMSRoutesName.ADMIN_WMS_SUMMARY} />
                        </SidebarItem>
                        <SidebarItem
                            to={WMSRoutes.ADMIN_WMS_STATS}
                            selected={currentPath === WMSRoutes.ADMIN_WMS_STATS}
                        >
                            <FormattedMessage id={WMSRoutesName.ADMIN_WMS_STATS} />
                        </SidebarItem>
                    </SidebarNavMenu>

                    <SidebarItem
                        isTopLevel
                        icon={<ScanIcon />}
                        to={WMSRoutes.ASSOCIATION}
                        selected={currentPath === WMSRoutes.ASSOCIATION}
                    >
                        <FormattedMessage id={WMSRoutesName.ASSOCIATION} />
                    </SidebarItem>

                    <SidebarNavMenu
                        content={<FormattedMessage id={"wms.routes.sidebarNavMenu.mission"} />}
                        icon={<FlagIcon />}
                        open={[
                            WMSRoutes.NEW_MISSION,
                            WMSRoutes.MISSION_LIST,
                            WMSRoutes.MISSION_MODEL_LIST
                        ].includes(currentPath)}
                    >
                        <SidebarItem
                            to={WMSRoutes.NEW_MISSION}
                            selected={currentPath === WMSRoutes.NEW_MISSION}
                        >
                            <FormattedMessage id={WMSRoutesName.NEW_MISSION} />
                        </SidebarItem>
                        <SidebarItem
                            to={WMSRoutes.MISSION_LIST}
                            selected={currentPath === WMSRoutes.MISSION_LIST}
                        >
                            <FormattedMessage id={WMSRoutesName.MISSION_LIST} />
                        </SidebarItem>
                        <SidebarItem
                            to={WMSRoutes.MISSION_MODEL_LIST}
                            selected={currentPath === WMSRoutes.MISSION_MODEL_LIST}
                        >
                            <FormattedMessage id={WMSRoutesName.MISSION_MODEL_LIST} />
                        </SidebarItem>
                    </SidebarNavMenu>
                </>
            )}
            <SidebarItem
                isTopLevel
                icon={<UserSquareIcon />}
                to={WMSRoutes.PICKING}
                selected={currentPath === WMSRoutes.PICKING}
            >
                <FormattedMessage id={WMSRoutesName.PICKING} />
            </SidebarItem>
            <SidebarItem
                isTopLevel
                icon={<SortIcon />}
                to={WMSRoutes.SORTING}
                selected={currentPath === WMSRoutes.SORTING}
            >
                <FormattedMessage id={WMSRoutesName.SORTING} />
            </SidebarItem>
            <SidebarItem
                isTopLevel
                icon={<BoxIcon />}
                to={WMSRoutes.PACKING}
                selected={currentPath === WMSRoutes.PACKING}
            >
                <FormattedMessage id={WMSRoutesName.PACKING} />
            </SidebarItem>
            <SidebarItem
                isTopLevel
                icon={<SortIcon />}
                to={WMSRoutes.TRI_SHIPPING}
                selected={currentPath === WMSRoutes.TRI_SHIPPING}
            >
                <FormattedMessage id={WMSRoutesName.TRI_SHIPPING} />
            </SidebarItem>
            <SidebarNavMenu
                content={'C&C'}
                icon={<BagIcon />}
                open={[
                    WMSRoutes.CC_LIST,
                    WMSRoutes.CC_HAND_OVER,
                    WMSRoutes.CC_RECEPTION_LIST
                ].includes(currentPath)}
            >
                <SidebarItem
                    to={WMSRoutes.CC_LIST}
                    selected={currentPath === WMSRoutes.CC_LIST}
                >
                    <FormattedMessage id={WMSRoutesName.CC_LIST} />
                </SidebarItem>
                <SidebarItem
                    to={WMSRoutes.CC_HAND_OVER}
                    selected={currentPath === WMSRoutes.CC_HAND_OVER}
                >
                    <FormattedMessage id={WMSRoutesName.CC_HAND_OVER} />
                </SidebarItem>
                <SidebarItem
                    to={WMSRoutes.CC_RECEPTION_LIST}
                    selected={currentPath === WMSRoutes.CC_RECEPTION_LIST}
                >
                    <FormattedMessage id={WMSRoutesName.CC_RECEPTION_LIST} />
                </SidebarItem>
            </SidebarNavMenu>
            <SidebarItem
                isTopLevel
                icon={<TruckIcon/>}
                to={WMSRoutes.SHIPPING}
                selected={currentPath === WMSRoutes.SHIPPING}
            >
                <FormattedMessage id={WMSRoutesName.SHIPPING} />
            </SidebarItem>
            <SidebarItem
                isTopLevel
                icon={<ScanIcon />}
                to={WMSRoutes.LOGS}
                selected={currentPath === WMSRoutes.LOGS}
            >
                <FormattedMessage id={WMSRoutesName.LOGS} />
            </SidebarItem>
        </div>
    );
}

export default WMSMenu;
